import { render, staticRenderFns } from "./diaogou.vue?vue&type=template&id=bac3916c&scoped=true"
var script = {}
import style0 from "./diaogou.vue?vue&type=style&index=0&id=bac3916c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac3916c",
  null
  
)

export default component.exports